import { cloneDeep } from 'lodash'
import React, { useContext, useState, useImperativeHandle, useEffect } from 'react';
import { useSearchParams, useLocation } from "react-router-dom";
import D3Icon from '../../../static/img/3d_0.png'
import BackupIcon from '../../../static/img/backup.png'
import ForwardIcon from '../../../static/img/forward.png'
import RemoveIcon from '../../../static/img/remove.png'
import TContext from '../context'
import PCPluginsContext from '../context'
import { Dialog, Toast, Icon, Button, Divider } from '@nutui/nutui-react';
import { Events } from "../action_title";
import http, { uploadFile } from '../../../lib/http';
import * as apis from '../../../lib/apis'
import saveIcon from '../../../images/save-model.png';
import saveIcon2 from '../../../images/save-a.png';


export const Height = 50

const iconBox: React.CSSProperties = {
    // backgroundColor: "#f9f9f9",
    width: 34,
    height: 34,
    display: "flex",
    // borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
}

const buttonClass = {
    color: '#ffffff',
    marginLeft: '10px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '18px',
    marginRight: '20px',
    display: 'flex',
    alignItems: 'center',
};
const buttonSave = {
    color: '#ffffff',
    border: 'none',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: 400,
    marginRight: '20px',
    display: 'flex',
    alignItems: 'center',
};
const iconBoxImg: React.CSSProperties = {
    width: "85%",
    height: "85%",
    display: "block",
    borderRadius: "50%"
}

const orderBtn: React.CSSProperties = {
    color: "#FFFFFF",
    backgroundColor: "#1890FF",
    fontSize: 14,
    fontWeight: 500,
    height: 35,
    padding: "0 18px",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    cursor: 'pointer'
}

export interface Action {
    addStep?: (j: any) => void;
    registEvent?: (s: Events) => void; //注册事件
    getCurrentStep?: () => number; // 新增：获取当前步骤
    setStep?: (step: number) => void; // 新增：设置步骤
    getHistoryData?: () => any[]; // 新增：获取历史数据
    onHistoryChange?: () => void;
}

export interface Props {
    action?: any
}


const Index = (props: Props) => {
    const [step, setStep] = useState<number>(-1)
    const tc = useContext(TContext)
    const pcPlugins = useContext(PCPluginsContext)
    const [showSaveDialog, setShowSaveDialog] = useState(false);
    const [modelName, setModelName] = useState('');
    const [saving, setSaving] = useState(false);
    const [title, setTitle] = useState('');
    const [threeDUrl, setThreeDUrl] = useState<any>({})
    const [searchParams] = useSearchParams();
    const product_id = searchParams.get("product_id");
    const urlParams = new URLSearchParams(useLocation().search);
    const design_id = urlParams.get("design_id");
    const addStep = (j = null) => {
        const newStep = tc.fabricClient.addEditData(null, step) - 1;
        setStep(newStep);

        // 通知父组件历史记录已更新
        if (props.action?.current?.onHistoryChange) {
            props.action.current.onHistoryChange();
        }
    }
    const [pickerShow, setPickerShow] = useState(false)

    //获取当前步骤
    const getCurrentStep = () => {
        return step;
    }
    useEffect(() => {
        http.get(`/api/basic_config`).then((res: any) => {
            setThreeDUrl(res?.diy_url || {})
        })
    }, [])
    useEffect(() => {
        if (tc?.detailData?.name) {
            setModelName(tc.detailData.name);
        } else {
            setModelName('');
        }
    }, [tc?.detailData?.name]);
    //设置步骤
    const setStepExternal = (newStep: number) => {
        setStep(newStep);
    }
    //获取历史数据
    const getHistoryData = () => {
        return tc.fabricClient?.getEditData() || [];
    }
    useImperativeHandle(props.action, (): Action => ({
        addStep,
        getCurrentStep,
        setStep: setStepExternal,
        getHistoryData,
    }));

    const backDataDisabled = () => {
        return step < 0
    }

    const forwardDataDisabled = () => {
        return ((step + 1) === tc.fabricClient?.getEditData()?.length)
    }
    const backEditData = async (e: any) => {
        e.preventDefault()
        if (backDataDisabled()) {
            return
        }

        const targetStep = step - 1

        Toast.loading(t("加载中"), {
            cover: true,
            closeOnClickOverlay: false,
            duration: 0
        })

        try {
            await new Promise(resolve => setTimeout(resolve, 10))
            if (targetStep === -1) {
                for (let code in tc.fabricClient.canvaes) {
                    tc.fabricClient.canvaes[code].clear()
                    tc.fabricClient.canvaes[code].renderAll()
                }
            } else {
                await tc.fabricClient.recoverEditData(targetStep)
            }

            tc.checkNotEmptyCodes!()
            setStep(targetStep)

            // 通知父组件历史记录更新
            if (props.action?.current?.onHistoryChange) {
                props.action.current.onHistoryChange();
            }


            // 确保loading显示足够时间后再切换
            await new Promise(resolve => setTimeout(resolve, 100))
            Toast.hide()
            await new Promise(resolve => setTimeout(resolve, 50))
            Toast.success(t("操作成功"))
            tc.setHasUnsavedChanges?.(false);

        } catch (error) {
            Toast.hide()
            await new Promise(resolve => setTimeout(resolve, 50))
            Toast.fail(t("操作失败"))
        }
    }
    const forwardEditData = async (e: any) => {
        e.preventDefault()
        if (forwardDataDisabled()) {
            return
        }
        let cloneStep: any = cloneDeep(step)
        cloneStep++
        setStep(cloneStep)
        Toast.loading(t("加载中"), {
            cover: true, // 是否展示透明遮罩层
            closeOnClickOverlay: false, // 点击遮罩可关闭
            duration: 0
        })
        await tc.fabricClient.recoverEditData(cloneStep)
        tc.checkNotEmptyCodes!()

        // 通知父组件历史记录更新
        if (props.action?.current?.onHistoryChange) {
            props.action.current.onHistoryChange();
        }

        Toast.success(t("操作成功"))
        Toast.hide()
        tc.setHasUnsavedChanges?.(false);
    }

    //清除所有纹样
    const clearAllObject = (e: any) => {
        e.preventDefault()
        console.log(tc.notEmptyCodes, "tc.notEmptyCodes")
        // if (tc.notEmptyCodes?.length === 0 && tc.hasUnsavedChanges) {
        //     return
        // }
        Dialog.alert({
            title: t('重置提醒'),
            content: t('确定重置模型吗？'),
            okText: t('确定'),
            cancelText: t('取消'),
            onOk: () => {
                if (tc.fabricClient?.canvaes) {
                    Object.keys(tc.fabricClient.canvaes).forEach(code => {
                        const canvas = tc.fabricClient.canvaes[code]
                        if (canvas) {
                            // 删除背景颜色
                            delete canvas.backgroundColor
                            // 清除背景图片
                            canvas.backgroundImage = null,
                                // 重置模型位置
                                tc?.titleChange(tc?.detailData?.model_materials.cutparts[0].code, tc?.detailData);
                            canvas.renderAll()
                        }
                    })
                }
                tc.fabricClient.clearAll()
                tc.fabricClient.clearEditData()

                tc.checkNotEmptyCodes!()
                setStep(-1)
                tc?.threeClient?.resetAllColors()
                Toast.success(t("操作成功"))
            }
        });
        tc?.setHasUnsavedChanges?.(true);

    }
    const sleep = (t: number) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null)
            }, t)
        })
    }
    const makeAndUploadImage = async (onProgress: any) => {
        //停止3D与2D的更新
        tc?.threeClient?.stopNeedsUpdate()
        const data: any = { effect_img: [], cutpart_img: [] }
        for (let i = 0; i < tc?.detailData?.model_materials?.cutparts?.length; i++) {
            let item = tc?.detailData?.model_materials?.cutparts[i]
            if (item.camera) {
                tc?.threeClient?.setCamera(item.camera.x, item.camera.y, item.camera.z)
            }
            await sleep(300)
            //获取blob
            const blob = await tc?.threeClient?.screePhoto()
            //上传效果图
            const ossData: any = await uploadFile(apis.UPLOAD_IMAGE, blob)
            if (!ossData.data.url) {
                Toast.fail(t("资源文件上传失败"))
                setShowSaveDialog(false);
                return
            }
            data.effect_img.push({
                code: item.code,
                img: ossData.data.url
            })
            onProgress(i / (tc?.detailData?.model_materials?.cutparts?.length - 1) * 100)
        }
        return data
    }
    //确认
    const confirm = (e: any) => {
        e.preventDefault();
        tc?.onSubComplete!(tc?.curEvent as Events)
    }

    //保存模型
    const saveModel = async (e: any) => {
        setShowSaveDialog(true);
        setTitle(t('保存模型'));
    }
    const handleConfirmSave = async () => {
        console.log(modelName, 'modelName')

        if (!modelName.trim()) {
            Toast.text(t('请输入模型名称'));
            return;
        }
        // 如果点击的是保存的话  就判断是否有design_id 如果没有就提示
        // if (!design_id) {
        //     Toast.text(t('没有设计id'))
        //     return;
        // }
        setSaving(true);

        try {
            const mdata = await makeAndUploadImage((p: any) => {
            })
            const resourceData: any = {}
            resourceData.canvas_width = tc?.fabricW as number
            resourceData.canvas_data = tc?.fabricClient?.allToJson()
            for (let i = 0; i < resourceData.canvas_data.length; i++) {
                let item = resourceData.canvas_data[i]
                let f = tc?.detailData?.model_materials?.cutparts?.find((j: any) => j.code === item.code)
                if (f) {
                    item.name = f.txt
                }
            }

            resourceData.model_url = tc?.detailData?.model_materials?.obj_url
            resourceData.map_info = tc?.curFabric
            resourceData.materials = mdata
            const ossData: any = await uploadFile(apis.UPLOAD_IMAGE, new Blob([JSON.stringify(resourceData)], { type: 'text/plain' }), "json")
            if (!ossData.data.url) {
                Toast.fail(t("提交失败,请重试"))
                Toast.hide()
                return
            }
            let url = design_id ? apis.USER_DESIGNER_UPDATE + '/' + tc?.detailData?.user_designer?.id : apis.USER_DESIGNER_SAVE;

            const data = {
                name: modelName,
                product_id: tc?.detailData?.product_info?.id,
                model_id: tc?.detailData?.model_id,
                resource_url: ossData.data.url,
            }
            Toast.loading("保存中", {
                cover: true, // 是否展示透明遮罩层
                closeOnClickOverlay: false, // 点击遮罩可关闭
                duration: 0
            })
            http.post(url, data).then((res: any) => {
                console.log(res, "res")
                // 打开新窗口
                Toast.success(t("操作成功"))
                // window.open('http://192.168.0.24:50923/user/designList?page_type=8', '_blank');
                window.open(`${process.env.NODE_ENV === 'development' ? 'http://192.168.0.24:50923' : threeDUrl}/user/designList?page_type=8`, '_blank');
            })
            // window.location.replace(`${process.env.NODE_ENV === 'development' ? 'http://jxfdiy.zw.com' : threeDUrl}/order_confirm?new=1&cartId=${res.cartId}`)

            reset()
            setSaving(false);

        } catch (error) {
            Toast.hide()
        }
    }
    const reset = () => {
        if (tc?.detailData?.name) {
            setModelName(tc.detailData.name);
        }
        setShowSaveDialog(false);

    };

    //下单
    const readyDoOrder = () => {
        addStep()
        tc.checkNotEmptyCodes!()
        pcPlugins?.doOrder!()
    }

    const preview3D = () => {
        tc.preview3D!()
    }
    const optionDataHandle = () => {
        const arr = []
        for (let i = 0; i < tc.detailData?.model_materials?.cutparts?.length; i++) {
            let item = tc.detailData?.model_materials?.cutparts[i]
            arr.push({ text: item.txt, value: item.code })
        }
        if (!tc.curCutpartCode) {
            return []
        }
        return arr
    }

    const cutpartOptions = optionDataHandle()
    return (
        <div style={{
            height: Height,
            display: "flex",
            alignItems: "center",
        }}>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 12px",
                margin: "0 auto",
                width: "100%",
                background: "#485563",
                zIndex: 999

            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    width: '30%'
                }}>
                    <Divider direction="vertical" />
                    {/* <div onClick={preview3D} style={{ display: 'flex', alignItems: 'baseline', marginRight: 10, cursor: 'pointer' }}>
                        <div style={{ ...iconBox, }}>
                            <i className="fpd-icon-preview-lightbox" style={{ width: '18px', height: '18px' }}></i>
                        </div>
                        <div style={{ color: '#fff', lineHeight: '36px' }}>Preview</div>
                    </div> */}


                    {/* <div style={tc?.hasUnsavedChanges! ? buttonClass : { ...buttonClass, opacity: 0.5, cursor: 'not-allowed' }} onClick={confirm}>
                        <img src={saveIcon} alt="" style={{ width: '18px', height: '18px', marginRight: '10px' }} />
                        <div style={{ color: '#fff', lineHeight: '36px' }}>{t('保存草稿')}</div>

                    </div> */}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#fff',
                    }}>
                        <div>{t('模型部位')}：</div>
                        <div onClick={(e) => {
                            e.stopPropagation()
                            setPickerShow(!pickerShow)
                        }} style={{
                            // width: 80,
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center",
                            fontSize: 14,
                            position: "relative",
                            cursor: 'pointer'
                        }}>
                            {cutpartOptions.map(v => {
                                const translatedText = t(v.text);
                                return (
                                    <div
                                        key={v.value}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            tc?.titleChange(v.value);
                                            if (tc.textAc?.current) {
                                                tc.textAc?.current?.confirm();
                                            }
                                        }}
                                        style={{
                                            padding: '5px 10px',
                                            cursor: 'pointer',
                                            marginRight: 8,
                                            backgroundColor: v.value === tc?.curCutpartCode ? '#1890ff' : 'transparent',
                                            color: v.value === tc?.curCutpartCode ? '#fff' : '#fff',
                                            borderRadius: 4,
                                            border: v.value === tc?.curCutpartCode ? '1px solid #1890ff' : '1px solid rgba(255,255,255,0.3)',
                                            fontSize: 14,
                                            transition: 'all 0.3s',
                                            whiteSpace: 'nowrap',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = v.value === tc?.curCutpartCode ? '#1890ff' : 'rgba(255,255,255,0.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = v.value === tc?.curCutpartCode ? '#1890ff' : 'transparent';
                                        }}
                                    >
                                        {translatedText}
                                    </div>
                                );
                            })}
                        </div>


                    </div>

                </div>

                {/* <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '120px',
                }}>
                    <div onClick={backEditData} style={{ ...iconBox, opacity: backDataDisabled() ? 0.5 : 1, justifyContent: 'center', alignItems: 'center', }}>
                        <i className="fpd-icon-undo" style={{ width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}></i>
                    </div>
                    <div onClick={forwardEditData} style={{ ...iconBox, opacity: forwardDataDisabled() ? 0.5 : 1 }}>
                        <i className="fpd-icon-redo" style={{ width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}></i>
                    </div>
                </div> */}

                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: "center",
                    width: '30%'
                }}>
                    <div onClick={clearAllObject} style={{ display: 'flex', alignItems: 'baseline', marginRight: 16, cursor: 'pointer', }}>
                        <div style={{ ...iconBox }}>
                            <i className="fpd-icon-reset" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}></i>
                        </div>
                        <div style={{ color: '#fff', lineHeight: '36px' }}>Reset</div>
                    </div>
                    {product_id ? (
                        <>
                            {/* <div style={buttonSave} onClick={saveModel}>
                                <img src={saveIcon2} alt="" style={{ width: '18px', height: '18px', marginRight: '10px' }} />
                                {t('保存')}
                            </div> */}
                            <div style={orderBtn} onClick={() => readyDoOrder()}>
                                <i className="fpd-icon-done" style={{ width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}></i>
                                Place an order
                            </div>
                        </>
                    ) : null
                    }

                </div>

                {showSaveDialog && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 10000,
                    }}>
                        <div style={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '24px',
                            width: '420px',
                            maxWidth: '90vw',
                            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
                            animation: 'fadeIn 0.3s ease-out',
                        }}>
                            <h3 style={{
                                margin: '0 0 20px 0',
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#333',
                                textAlign: 'center',
                            }}>
                                {title}
                            </h3>

                            <div style={{ marginBottom: '20px', marginRight: '32px', }}>
                                <input
                                    type="text"
                                    placeholder={t('请输入模型名称')}
                                    value={modelName}
                                    onChange={(e) => setModelName(e.target.value)}
                                    style={{
                                        width: '100%',
                                        height: '44px',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '6px',
                                        padding: '0 16px',
                                        fontSize: '14px',
                                        outline: 'none',
                                        transition: 'border-color 0.3s',
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#485563';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#e0e0e0';
                                    }}

                                    autoFocus
                                />

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: '8px',
                                }}>
                                    <span style={{
                                        fontSize: '12px',
                                        color: '#999',
                                    }}>
                                        {modelName.length}/50
                                    </span>
                                </div>
                            </div>

                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                justifyContent: 'flex-end',
                            }}>
                                <button
                                    onClick={reset}
                                    disabled={saving}
                                    style={{
                                        padding: '10px 20px',
                                        border: '1px solid #dcdfe6',
                                        borderRadius: '6px',
                                        backgroundColor: 'white',
                                        color: '#606266',
                                        cursor: saving ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        minWidth: '80px',
                                        opacity: saving ? 0.6 : 1,
                                    }}
                                >
                                    {t('取消')}
                                </button>
                                {/* <button
                                    onClick={() => handleConfirmSave('另存为')}
                                    disabled={saving}
                                    style={{
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '6px',
                                        backgroundColor: saving ? '#a0cfff' : '#485563',
                                        color: 'white',
                                        cursor: saving ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        minWidth: '80px',
                                        transition: 'background-color 0.3s',
                                    }}
                                >
                                    {t('另存为')}
                                </button> */}
                                <button
                                    onClick={() => handleConfirmSave()}
                                    disabled={saving}
                                    style={{
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '6px',
                                        backgroundColor: saving ? '#a0cfff' : '#485563',
                                        color: 'white',
                                        cursor: saving ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        minWidth: '80px',
                                        transition: 'background-color 0.3s',
                                    }}
                                >
                                    {saving ? t('保存中') : t('保存')}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <style>
                    {`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: scale(0.9);
                    }
                    to {
                        opacity: 1;
                        transform: scale(1);
                    }
                }
                `}
                </style>
            </div>
        </div >
    )
}

export default Index
